module.exports = __webpack_public_path__ + "static/img/logo.ef4731f9.png";